import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react"; // Optional: use any icon or SVG

const GoToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when user scrolls down
    useEffect(() => {
       /* const toggleVisibility = () => {
            setIsVisible(window.scrollY > 900);
        };*/

        const toggleVisibility = () => {
            const bottom = document.documentElement.scrollHeight - window.innerHeight;
            setIsVisible(window.scrollY >= bottom - 10);
        };


        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        isVisible && (
            <button
                onClick={scrollToTop}
                className="fixed bottom-6 right-6 z-50 p-3 rounded-full bg-black text-white hover:bg-gray-800 transition shadow-lg"
                aria-label="Scroll to top"
            >
                <ArrowUp className="w-5 h-5" />
            </button>
        )
    );
};

export default GoToTopButton;
